import m from "../../geodata/es2015/maliLow";
window.am4geodata_maliLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/maliLow.js
// module id = null
// module chunks = 